import { quoteTransportChildrenFormDefault } from "@factory/form/form.default";
import { QuotationFormSchema } from "@factory/form/form.rule";
import { GetUtilAgeBracketModel } from "@factory/model/query-model-util-age-bracket";
import { useQyGetUtilAgeBracket } from "@factory/query/util-age-bracket.query";
import { LabelValue } from "@shared/models/label-value.interface";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

interface QuoteTransportChildrenProps {
  rowIndex: number;
}

type InputFormSchema = QuotationFormSchema;
export default function QuoteTransportChildren({
  rowIndex,
}: QuoteTransportChildrenProps) {
  const { control, setValue, getValues, watch } =
    useFormContext<QuotationFormSchema>();
  const [ageBrackets, setAgeBrackets] = useState<LabelValue[]>([]);
  const [unmappedAgeBrackets, setUnmappedAgeBrackets] = useState<GetUtilAgeBracketModel[]>([])

  const transportTypeId = watch(`transport.${rowIndex}.transportType`);
  const { fields, append, remove } = useFieldArray({
    control,
    name: `transport.${rowIndex}.childPrices`,
  });

  useQyGetUtilAgeBracket(
    "",
    9999,
    0,
    undefined,
    { type: transportTypeId || "" },
    true,
    (response) => {
      const mappedSuggestions = (response?.data || [])
        .map((item) => ({
          label: `${item.name}`,
          value: item.code,
        }))
        .filter((x) => !!x.label);
      // Set the suggestions for the dropdown control
      setAgeBrackets(mappedSuggestions);
      setUnmappedAgeBrackets(response?.data || [])
    }
  );

  return (
    <div>
      <Divider />
      <div className="mb-2">
        <h4>Child Options</h4>
        <Button
          label="Add Child Option"
          onClick={() => append(quoteTransportChildrenFormDefault)}
        />
      </div>
      {fields?.map((childOption, index) => (
        <div key={index} className="bg-blue-50 p-2 rounded-md mb-2 border">
          <div className="flex justify-end">
            <Button
              severity="danger"
              type="button"
              className="mt-2"
              onClick={() => remove(index)}
              icon="pi pi-trash"
            ></Button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            <DropdownControl
              control={control}
              options={ageBrackets}
              label="Age Bracket"
              placeholder="Select Age Bracket"
              className="w-full"
              name={`transport.${rowIndex}.childPrices.${index}.ageBracket`}
              onSelect={(value) => {
                const ageBracket = unmappedAgeBrackets.find((ab) => ab.code === value);
                setValue(`transport.${rowIndex}.childPrices.${index}.childPricePerPax`, ageBracket?.price)
              }}
            />
            <InputDigitControl<InputFormSchema>
              control={control}
              name={`transport.${rowIndex}.childPrices.${index}.childPricePerPax`}
              label="Price per pax"
              className="w-full"
              containerClassName="pb-2"
              placeholder="Enter child per pax"
              onValueChange={(value) => {
                const numChildren = getValues(`transport.${rowIndex}.childPrices.${index}.numChildren`)
                setValue(`transport.${rowIndex}.childPrices.${index}.amount`, 
                      (value || 0) * (numChildren || 0)
                )
              }}
            />
            <InputDigitControl<InputFormSchema>
              control={control}
              name={`transport.${rowIndex}.childPrices.${index}.numChildren`}
              label="Number of children"
              className="w-full"
              containerClassName="pb-2"
              placeholder="Enter to number of children"
              onValueChange={(value) => {
                const childPricePerPax = getValues(`transport.${rowIndex}.childPrices.${index}.childPricePerPax`)
                setValue(`transport.${rowIndex}.childPrices.${index}.amount`, 
                      (value || 0) * (childPricePerPax || 0)
                )
              }}
            />
            <InputDigitControl<InputFormSchema>
              control={control}
              name={`transport.${rowIndex}.childPrices.${index}.amount`}
              label="Amount"
              className="w-full"
              containerClassName="pb-2"
              placeholder="Enter to amount"
            />
          </div>
        </div>
      ))}
    </div>
  );
}
